import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=0626a9c6&scoped=true&"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPage.vue?vue&type=style&index=0&id=0626a9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626a9c6",
  null
  
)

export default component.exports